import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { QuickDialog } from '../utilities/Dialog/QuickDialog';
import { UserService } from '../services/user-service/user.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.css']
})
export class PasswordResetComponent implements OnInit {


  link = "";
  password = "";
  confirm = "";

  constructor(private dialog: MatDialog, private userServ: UserService, private route: ActivatedRoute,private router:Router) {

  }

  ngOnInit() {
    this.link = this.route.snapshot.params.id;
  }

  submitPasswordChange() {

    if (this.password == null) {
      new QuickDialog(this.dialog).InfoDialog("Password Must be at least 6 characters in length", "Invalid Password", "OK");
    } else if (this.password.trim() == "" || this.password.trim().length < 6) {
      new QuickDialog(this.dialog).InfoDialog("Password Must be at least 6 characters in length", "Invalid Password", "OK");
    } else if (this.password != this.confirm) {
      new QuickDialog(this.dialog).InfoDialog("Password and Confirm Password Must Match", "No Match", "OK");
    } else {
      this.userServ.resetPassword(this.link, this.password).then((result: any) => {
        if (result.status) {

          new QuickDialog(this.dialog).InfoDialog("Your password has been reset you may now log in with the new password", "Password Reset", "OK");
          this.router.navigate(['/user/login']);
        } else {

          new QuickDialog(this.dialog).InfoDialog("Unable To Reset The Password", "Sorry", "OK");
        }
      }).catch(e => {

        new QuickDialog(this.dialog).InfoDialog("Unable To Reset The Password", "Sorry", "OK");
      });
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/password-reset/password-reset.component.ts